import { Message } from "primeng/api";
import { ErroService } from "../service/erro.service";
import { Empresa } from "../api/dto/empresa";
import { AuthUtil } from "../util/auth-util";
import { UtilStorageService } from "../service/util-storage.service";
import { Usuario } from "../api/dto/usuario";
import { ActivatedRoute, Router } from "@angular/router";
import { Administradora } from "../api/dto/administradora";
import { Caixa } from "../api/dto/caixa";

export abstract class AdmihairBaseComponent {

  public idParametroUrl?: number;
  private administradora?: Administradora;
  private empresa?: Empresa;
  private usuarioLogado?: Usuario;
  public exibirSpinnerPrincipal: boolean = false;
  public messages: Message[] = [];
  public messagemVisivel: boolean = false;
  public messagesDialog: Message[] = [];
  public messagemVisivelDialog: boolean = false;

  public permissaoListar: boolean = false;
  public permissaoInserir: boolean = false;
  public permissaoEditar: boolean = false;
  public permissaoExcluir: boolean = false;
  public permissaoDetalhar: boolean = false;

  constructor(private erroService: ErroService,
    private storageService: UtilStorageService,
    private router?: Router,
    private activatedRoute?: ActivatedRoute) { }


  public getAdministradora() {
    this.administradora = this.storageService.getAdministradora();
    return this.administradora;
   }
  
  public getEmpresa() {
    this.empresa = this.storageService.getEmpresa();
    return this.empresa;
  }

  public getUsuario() {
    this.usuarioLogado = this.storageService.getUser();
    return this.usuarioLogado;
  }

  public getUsuarioLogadoSistema() : Usuario{
    return this.storageService.getLoggedUser();
  }

  public setCaixaSelecionado(caixa: Caixa): void {
    this.storageService.saveCaixaSelecionado(caixa);
  }

  public getCaixaSelecionado(): Caixa | undefined {
    return this.storageService.getCaixaSelecionado();
  }

  public limparCaixaSelecionado() {
    this.storageService.limparCaixaSelecionado();
  }

  public verificarPermissao(nome: string): boolean {
    return AuthUtil.verificarPermissao(nome);
  }


  public isExibirSpinnerPrincipal(): boolean {
    return this.exibirSpinnerPrincipal;
  }

  public setExibirSpinnerPrincipal(exibe: boolean): void {
    this.exibirSpinnerPrincipal = exibe;
  }

  exibirMensagemErro(err: any) {
    this.messages = this.erroService.handleErro(err);
    this.messagemVisivel = true;
    this.rolarTela();
  }

  exibirMensagemErroPadrao() {
    this.messages = [{ severity: 'error', summary: 'Houve um erro não identificado no sistema' ,
                     detail: '' }];
    this.messagemVisivel = true;
    this.rolarTela();                
  }


  exibirMensagemSucesso() {
    this.messages = this.erroService.handleSuccess();
    this.messagemVisivel = true;
    this.rolarTela();
  }

  exibirMensagemErroDialog(err: any) {
    this.messagesDialog = this.erroService.handleErro(err);
    this.messagemVisivelDialog = true;
  }

  fecharMensagemErroDialog() {
    this.messagemVisivelDialog = false;
  }


  exibirMensagemSucessoDialog() {
    this.messagesDialog = this.erroService.handleSuccess();
    this.messagemVisivelDialog = true;
  }

  redirecionarPagina(url: string) {
    const urlAtual = this.router?.url;
    if(urlAtual !== url) {
      this.router?.navigate([url], { relativeTo: this.activatedRoute});
    } else {
      window.location.reload();
    }
  }

  redirecionarPaginaGeral(url: string) {
    this.router?.navigate([url]);
  }

  carregarIdUrl(){
    if(this.activatedRoute){
      const idParam = this.activatedRoute.snapshot.paramMap.get('id');
      if(idParam){
        this.idParametroUrl = parseInt(idParam);
      }
    }
  }

  carregarIdParametroUrl(nomeParametro?: string): string | null {
    if(this.activatedRoute && nomeParametro){
      return this.activatedRoute.snapshot.paramMap.get(nomeParametro);
    }
    return null;
  }

  rolarTela() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  rolarTelaBaixo() {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
    });
  }

}